export default "__VITE_ASSET__caa381ea__"